<template>
    <div class="enjoyPopup_box">
        <div class="jh_box">
            <img src="../../../static/image/enjoyImg/tejh.png" alt="" width="100%" @click="handleGo">
            <img src="../../../static/image/enjoyImg/close.png" style="margin-top:80px" alt="" width="50px" @click="handleClose">
            <!-- <van-icon @click="handleClose" class="icon_1" name="close" /> -->
        </div>
    </div>
</template>

<script>
export default {
    name:'enjoyPopup',
    data() {
        return {
            show:true
        }
    },

    methods: {
        // 前往优享服务
        handleGo() {
            this.$router.replace({path:'/enjoyBestService'})
        },

        // 关闭弹窗
        handleClose() {
            this.$emit('handleClose')
        }
    }
}
</script>

<style lang="less" scoped>
.enjoyPopup_box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 999;
    .jh_box {
        padding: 0 20px;
        display: flex;
        align-items: center;
        height: 100%;
        flex-direction: column;
        justify-content: center;
        .icon_1 {
            font-size: 40px;
            //  position: absolute;
            color: #999999;
            margin-top: 75px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/modules/Allpopup/enjoyPopup.vue